import React from 'react';
import { get } from 'lodash';
import { TableCell as MuiTableCell } from '@material-ui/core';

import { TableCellProps } from './table-types';

function defaultValueSelector({ row, column }: TableCellProps) {
  return get(row, column.id);
}

export function TableCell(props: TableCellProps) {
  const { valueSelector = defaultValueSelector } = props.column;
  const value = valueSelector(props);

  const CellComponent = props.column.CellComponent;

  return (
    <MuiTableCell width={props.column.width ?? 400}>
      {CellComponent ? (
        <CellComponent data={value} allData={props.row} />
      ) : (
        value
      )}
    </MuiTableCell>
  );
}
